import { resolvePowSolution as e } from "../phone/runPhoneOtpSend.mjs";
import { useMutation as t } from "@maat/store-hooks";
import { authApi as n } from "@maat/api-main";
//#region src/password/useForgotPasswordSendMutation.ts
var r = (r) => t({
	mutationFn: async (t) => {
		let i = await e(r);
		return n.forgotPasswordSend({
			...t,
			...i ? { pow_solution: i } : {}
		});
	},
	retry: !1
});
//#endregion
export { r as useForgotPasswordSendMutation };
